import { r as registerInstance, c as createEvent, h, g as getElement, H as Host, F as Fragment } from './index-16dc7dde.js';
import { r as rangeBasePath, n as EEvent, o as ETabType } from './request.constants-deb285e0.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import { a as getCurrentReference } from './range-helpers-2dd7a4ef.js';
import { v as addParameterToLink, w as getQueryParam, ar as pasteScripts, as as productCtasButtonType, at as productCtasColors, I as scrollToTop, a as isMobile, ae as getNavigationStateParam } from './utils-15ad90ec.js';
import { d as decodeFromURI } from './uri-6796e5e7.js';
import { c as classnames } from './index-136476ff.js';
import { i as isV3, s as scrollToComponent } from './lookups-705fb53e.js';
import { s as send, g as paginationClickEvent, B as rangeTabClickEvent } from './send-33ade633.js';
import { c as comparator } from './comparator-188d64f5.js';
import { g as getMyProductsFromConnector } from './utils-62e3520b.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { T as TAB_NAMES, g as rangeTabs } from './analytics-765d4daf.js';
import { s as setArticleTitle } from './helpers-71d81730.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import './path-9b025204.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isObject-33fa1780.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './utils-913bdf8a.js';
import './noop-9247c8ef.js';
import './promise-74c80706.js';
import './isTypedArray-dfccd669.js';

const rangeNodeCardCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-node-link{display:block;text-decoration:none}.range-node-link:hover{text-decoration:none}.range-node-link:visited{outline:none}.range-node-card{display:flex;flex-direction:column;align-items:center;width:280px;height:242px;border:1px solid #e7e6e6;background-color:#ffffff}.range-node-card:hover{text-decoration:none !important}.range-node-card:visited{outline:none !important}.range-node-card__img-wrapper{margin-top:30px}.range-node-card__img-wrapper img{width:140px;height:140px}.range-node-card__label-wrapper{align-self:flex-start}:host(:not([dir=\"rtl\"])) .range-node-card__label-wrapper{margin-left:30px}:host([dir=\"rtl\"]) .range-node-card__label-wrapper{margin-right:30px}.range-node-card__label{color:#626469;text-decoration:none}";

let RangeInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a, _b;
    return (h("a", { href: !this.isPBS ? this.url : '#', class: "range-node-link", onClick: (event) => {
        if (this.isPBS) {
          event.preventDefault();
          this.nodeSelected.emit({
            id: this.id,
            image: this.image,
            url: this.url,
            name: this.name,
            nodeReference: this.nodeReference,
            nodes: this.nodes,
            navigationState: this.navigationState,
          });
        }
      } }, h("div", { class: "range-node-card" }, h("div", { class: "range-node-card__img-wrapper" }, h("img", { src: (_a = this.image) === null || _a === void 0 ? void 0 : _a.url, alt: (_b = this.image) === null || _b === void 0 ? void 0 : _b.alt })), h("div", { class: "range-node-card__label-wrapper" }, h("p", { class: "range-node-card__label" }, this.name)))));
  }
  get el() { return getElement(this); }
};
RangeInfo.style = rangeNodeCardCss;

const rangeNodeHeaderCss = "@media screen and (max-width: 979px){.range-node-header{text-align:center}}.range-node-header__back-link-wrapper{display:flex;align-items:center;height:20px;font-size:0.875rem;line-height:1.25rem;text-decoration:none;outline:none}.range-node-header__back-link-wrapper:hover{text-decoration:underline}@media screen and (max-width: 979px){.range-node-header__back-link-wrapper{justify-content:center}}.range-node-header__back-link-wrapper:hover,.range-node-header__back-link-wrapper a:hover{font-size:0.875rem;line-height:1.25rem;text-decoration:none}.range-node-header__back-link{display:flex;align-items:center;height:20px;line-height:1.25rem}.range-node-header__back-link-icon{color:#42b4e6}:host(:not([dir=\"rtl\"])) .range-node-header__back-link-icon{margin-right:6px}:host([dir=\"rtl\"]) .range-node-header__back-link-icon{margin-left:6px;transform:scaleX(-1)}.range-node-header__back-link-text{display:inline-block;vertical-align:top}.range-node-header__back-link-text:hover{text-decoration:underline}.range-node-header__prev-level-title{font-size:0.875rem;line-height:1.25rem;font-weight:400;color:#626469}:host(:not([dir=\"rtl\"])) .range-node-header__prev-level-title{margin:0 0 0 24px}:host([dir=\"rtl\"]) .range-node-header__prev-level-title{margin:0 24px 0 0}";

let RangeNodeHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.previousNodeSelected = createEvent(this, "previousNodeSelected", 7);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.handleLinkClick = (event) => {
      if (!this.isPBS)
        return;
      event.preventDefault();
      this.previousNodeSelected.emit();
      this.nodeSelected.emit({
        nodeReference: getCurrentReference(Boolean(this.backUrl), rangeBasePath, this.backUrl, this.isPBS),
      });
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "range-node-header" }, this.backUrl && (h("div", { class: "range-node-header__back-link-wrapper" }, h("se-icon", { size: pesIconSizes.NANO, class: "range-node-header__back-link-icon" }, "arrow2_left"), h("se-link", { unicolor: true, url: this.isPBS ? '#' : this.backUrl, onClick: this.handleLinkClick, class: "range-node-header__back-link" }, h("span", { class: "range-node-header__back-link-text", innerHTML: this.backUrlTitle })))), this.levelTitle && h("h4", { class: "range-node-header__prev-level-title" }, this.levelTitle)));
  }
  get el() { return getElement(this); }
};
RangeNodeHeader.style = rangeNodeHeaderCss;

const rangeNodesCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-nodes-list{display:flex;flex-wrap:wrap;list-style-type:none;margin:24px 0 0;padding:0;overflow-y:hidden}@media screen and (max-width: 979px){.range-nodes-list{flex-direction:column}}.range-nodes-list__item{margin-bottom:20px}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:not(:last-child){margin-right:20px}:host([dir=\"rtl\"]) .range-nodes-list__item:not(:last-child){margin-left:20px}@media screen and (max-width: 979px){.range-nodes-list__item:not(:last-child){margin-bottom:20px}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:not(:last-child){margin-right:auto}:host([dir=\"rtl\"]) .range-nodes-list__item:not(:last-child){margin-left:auto}}:host(:not([dir=\"rtl\"])) .range-nodes-list__item:nth-child(4n){margin-right:0}:host([dir=\"rtl\"]) .range-nodes-list__item:nth-child(4n){margin-left:0}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .range-nodes-list__item:nth-child(4n){margin-right:auto}:host([dir=\"rtl\"]) .range-nodes-list__item:nth-child(4n){margin-left:auto}}@media screen and (max-width: 979px){.range-nodes-list__item{margin:0 auto}}";

let RangeNodes = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  nodeUrlWithParameters(url) {
    return addParameterToLink(url, {
      filter: getQueryParam('filter'),
    });
  }
  render() {
    var _a;
    return (h(Host, null, this.backUrl && (h("pes-range-node-header", { backUrl: this.backUrl, backUrlTitle: this.backUrlTitle, levelTitle: this.levelTitle, isPBS: this.isPBS })), ((_a = this.childrenNodes) === null || _a === void 0 ? void 0 : _a.length) > 0 && (h("ul", { class: "range-nodes-list" }, this.childrenNodes.map((node) => (h("li", { class: "range-nodes-list__item", key: node.id }, h("pes-range-node-card", { image: node.image, url: this.nodeUrlWithParameters(node.url), name: node.name, id: node.id, nodes: node.nodes, nodeReference: node.nodeReference, isPBS: this.isPBS, navigationState: node.navigationState }))))))));
  }
  get el() { return getElement(this); }
};
RangeNodes.style = rangeNodesCss;

const rangePresentationTabCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.range-presentation-tab{display:flex;margin:0 auto;padding:20px 7px 48px}@media screen and (min-width: 980px){.range-presentation-tab{padding:0 0 98px}}.range-presentation-tab ul{padding:0 0 12px}.range-presentation-tab ul li{list-style:disc inside;text-indent:0;margin-bottom:15px;color:#626469;font-size:0.8125rem;font-weight:400;line-height:1.21875rem}.range-presentation-tab p{color:#626469;font-size:0.8125rem;font-weight:400;line-height:1.21875rem}.range-presentation-tab strong{line-height:2.125rem}.range-presentation-tab table{width:100%}.range-presentation-tab__additional-links{display:flex;flex-wrap:wrap}.range-presentation-tab__additional-link{display:block;color:#42b4e6;font-size:0.8125rem;line-height:1.21875rem;padding:20px 15px;font-weight:700;text-decoration:none}.range-presentation-tab__additional-link:hover{text-decoration:none}.range-presentation-tab__additional-link-icon{width:20px;position:relative}.range-presentation-tab__additional-link:hover .range-presentation-tab__additional-link-icon{text-decoration:none}.range-presentation-tab__additional-link-wrapper{flex:1 0 100%;max-width:100%}@media screen and (min-width: 980px){.range-presentation-tab__additional-link-wrapper{flex:1 0 25%}}:host(:not([dir=\"rtl\"])) .range-presentation-tab__additional-link-text{margin-left:-8px}:host([dir=\"rtl\"]) .range-presentation-tab__additional-link-text{margin-right:-8px}.range-presentation-tab__additional-link:hover .range-presentation-tab__additional-link-text{text-decoration:underline}.range-presentation-tab__more-features{margin-top:20px}.list-images{display:flex;flex-wrap:wrap;justify-content:space-between}@media screen and (min-width: 980px){.list-images{justify-content:start}}.list-images__image{width:100%}.list-images li.list-images__image-wrapper{max-width:calc(50% - 20px);list-style:none;display:list-item;flex-direction:column;margin:0;padding:0;border-bottom:40px solid transparent}@media screen and (min-width: 980px){.list-images li.list-images__image-wrapper{width:196px;justify-content:start;border-bottom:40px solid transparent;border-left:20px solid transparent;border-right:20px solid transparent}}.range-presentation-tab__article+.range-presentation-tab__article{border-top:solid 1px #e6e6e6;margin-top:27px}.range-presentation-tab__article__header,.range-presentation-tab__article h3{font-size:2.5rem;color:#3dcd58;line-height:1.5em;font-weight:400;text-align:center}@media screen and (max-width: 979px){.range-presentation-tab__article__header,.range-presentation-tab__article h3{margin:0 0 20px}}@media screen and (min-width: 980px){.range-presentation-tab__article__header,.range-presentation-tab__article h3{text-align:left;margin:0 0 15px}}.range-presentation-tab__article iframe{max-width:100%}.range-presentation-tab__sdl-content{box-sizing:border-box}.range-presentation-tab__sdl-content *,.range-presentation-tab__sdl-content *::before,.range-presentation-tab__sdl-content *::after{box-sizing:inherit}@media screen and (max-width: 979px){.range-presentation-tab__sdl-content{margin-top:20px}}@media screen and (min-width: 980px){.range-presentation-tab__sdl-content{margin-top:40px}}.range-presentation-tab__sdl-content a:hover{text-decoration:underline}";

let RangePresentationTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderMoreFeatures() {
    if (this.presentation.presentation2) {
      return (h("div", { class: "range-presentation-tab__more-features", innerHTML: this.presentation.presentation2 }));
    }
  }
  renderArticle({ label, content = '', extraLayout = '' }) {
    if (label && (content || extraLayout)) {
      return (h("article", { class: "range-presentation-tab__article" }, h("h3", { class: "range-presentation-tab__article-header" }, label), content && h("div", { class: "range-presentation-tab__article-content", innerHTML: content }), extraLayout));
    }
  }
  getWrapped(text, type) {
    switch (type) {
      case 'b':
        return `<!--BENEFITS_BEGIN-->${text}<!--BENEFITS_END-->`;
      case 'f':
        return `<!--PRESENTATION_BEGIN-->${text}<!--PRESENTATION_END-->`;
      case 'a':
        return `<!--APPLICATIONS_BEGIN-->${text}<!--APPLICATIONS_END--> `;
      default:
        return text;
    }
  }
  renderBenefits() {
    if (this.presentation.benefits) {
      return this.renderArticle({
        label: this.presentation.rangePresentationBenefitsLabel,
        content: this.getWrapped(this.presentation.benefits, 'b'),
      });
    }
  }
  renderFeatures() {
    if (this.presentation.presentation1 || this.presentation.presentation2) {
      return this.renderArticle({
        label: this.presentation.rangePresentationFeaturesLabel,
        content: this.getWrapped(this.presentation.presentation1, 'f'),
        extraLayout: this.renderMoreFeatures(),
      });
    }
  }
  renderApplications() {
    if (this.presentation.rangeApplication) {
      return this.renderArticle({
        label: this.presentation.rangePresentationApplicationsLabel,
        content: this.getWrapped(this.presentation.rangeApplication, 'a'),
      });
    }
  }
  renderGallery() {
    if (this.presentation.images && this.presentation.images.length) {
      const extraLayout = (h("ul", { class: "list-images" }, this.presentation.images.map((i) => (h("li", { class: "list-images__image-wrapper" }, h("img", { class: "list-images__image", src: i.url, alt: i.title }))))));
      return this.renderArticle({ label: this.presentation.rangeGaleryLabel, extraLayout });
    }
  }
  renderAdditionalLinks() {
    if (this.presentation.additionalLinks && this.presentation.additionalLinks.length) {
      const extraLayout = (h("div", { class: "range-presentation-tab__additional-links" }, this.presentation.additionalLinks.map((link) => (h("div", { class: "range-presentation-tab__additional-link-wrapper" }, h("a", { href: link.url, target: link.target, class: "range-presentation-tab__additional-link" }, h("se-icon", { size: pesIconSizes.NANO, class: "range-presentation-tab__additional-link-icon", mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"), h("span", { innerHTML: link.label, class: "range-presentation-tab__additional-link-text" })))))));
      return this.renderArticle({
        label: this.presentation.rangeAdditionalLinksLabel,
        extraLayout,
      });
    }
  }
  componentDidRender() {
    if (this.presentation.sdlContent) {
      pasteScripts(this.el, '.overview-sdl-content');
    }
  }
  render() {
    if (this.presentation.sdlContent) {
      try {
        return (h("div", { class: "overview-sdl-content range-presentation-tab__sdl-content", innerHTML: decodeFromURI(this.presentation.sdlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return (h("div", { class: "range-presentation-tab" }, h("div", null, this.renderFeatures(), this.renderBenefits(), this.renderApplications(), this.renderGallery(), this.renderAdditionalLinks())));
  }
  get el() { return getElement(this); }
};
RangePresentationTab.style = rangePresentationTabCss;

const rangeProductsTabCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.range-products-tab{position:relative}@media screen and (max-width: 979px){.range-products-tab{display:block;padding-bottom:24px}}@media screen and (min-width: 980px){.range-products-tab{display:flex;flex-direction:column;overflow:visible;padding-bottom:48px}}.range-products-tab__nodes-wrapper{padding-top:32px}.range-products-tab__main-block-container{display:flex;flex-direction:column}@media screen and (min-width: 980px){.range-products-tab__main-block-container{flex-direction:row}}@media screen and (max-width: 979px){.range-products-tab__products-count{color:#626469;font-size:14px;line-height:20px;margin-bottom:12px}}@media screen and (min-width: 980px){.range-products-tab__products-count{display:none}}.range-products-tab__products{padding-top:24px;position:relative}@media screen and (min-width: 980px){.range-products-tab__products{padding-top:36px}}.range-products-tab__products--desktop{display:none}@media screen and (min-width: 980px){.range-products-tab__products--desktop{display:initial;overflow:visible}}@media screen and (min-width: 980px){.range-products-tab__products-list{display:block}:host(:not([dir=\"rtl\"])) .range-products-tab__products-list{margin-left:20px}:host([dir=\"rtl\"]) .range-products-tab__products-list{margin-right:20px}}.range-products-tab__overlay{z-index:2;top:0;right:0;bottom:0;left:0;background:#fafafa;opacity:0.4}.range-products-tab__overlay:not(.range-products-tab__overlay--visible){display:none}@media screen and (max-width: 979px){.range-products-tab__overlay{position:fixed}}@media screen and (min-width: 980px){.range-products-tab__overlay{position:absolute}}.range-products-tab__desktop-pagination{width:100%;text-align:center;margin-top:36px}@media screen and (max-width: 979px){.range-products-tab__desktop-pagination{display:none}}.range-products-tab__load-prev-btn{margin-bottom:20px}.range-products-tab__load-more-btn{margin-top:20px}@media screen and (min-width: 980px){.range-products-tab__load-prev-btn,.range-products-tab__load-more-btn{display:none}}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .range-products-tab__rich-text{margin-left:20px}:host([dir=\"rtl\"]) .range-products-tab__rich-text{margin-right:20px}}@media screen and (min-width: 980px){.range-products-tab__filters{padding-top:36px}}";

let RangeProductsTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pageSelected = createEvent(this, "pageSelected", 7);
    this.productCtas = {
      buttons: {
        [productCtasButtonType.CART]: {
          isShown: false,
          list: [],
          color: productCtasColors.PRIMARY_BLUE,
          icons: {
            addIcon: 'segment_retail',
            disableIconInPdpCtaBlock: true,
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
        [productCtasButtonType.FAVORITES]: {
          isShown: false,
          list: [],
          color: productCtasColors.SECONDARY_BLUE,
          icons: {
            addIcon: 'star_stroke',
            removeIcon: 'star_plain',
          },
          dataset: {
            daElementId: 'add_p',
          },
          labels: {},
        },
      },
      productProp: 'repositoryId',
    };
    this.showBuyOnline = true;
    this.showCompare = true;
    this.enableAppRouting = false;
    this.isFilterMobileViewVisible = false;
    this.isMobileView = false;
    this.comparatorValue = comparator.value;
    this.productCtasState = this.productCtas;
    this.handleComparatorChange = (e) => {
      this.comparatorValue = e.detail;
    };
    this.onPaginationChange = (event) => {
      const pageNumber = event.detail.value;
      send(paginationClickEvent, { articleTitle: pageNumber });
      this.pageSelected.emit(pageNumber);
      scrollToTop(this.el);
    };
    this.loadPrevious = () => {
      const previousPageNumber = Math.floor(this.firstLoadedRecNum / this.productsPerPage);
      send(paginationClickEvent, { articleTitle: previousPageNumber });
      this.pageSelected.emit(previousPageNumber);
      this.scrollToProduct = this.productsPerPage;
    };
    this.loadMore = () => {
      const nextPageNumber = Math.floor(this.lastLoadedRecNum / this.productsPerPage) + 1;
      send(paginationClickEvent, { articleTitle: nextPageNumber });
      this.pageSelected.emit(nextPageNumber);
      this.scrollToProduct = this.lastLoadedRecNum - this.firstLoadedRecNum + 1;
    };
    this.handleProductCtasChange = (event) => {
      if (!this.productCtas)
        return;
      if (this.isPBS) {
        this.productCtas = Object.assign({}, this.productCtas);
        return;
      }
      this.productCtas = Object.assign(Object.assign({}, this.productCtas), { buttons: event.detail });
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  windowSizeDidChange() {
    if (!isMobile() && this.isFilterMobileViewVisible === true) {
      this.isFilterMobileViewVisible = false;
    }
    this.isMobileView = isMobile();
  }
  connectedCallback() {
    window.addEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  disconnectedCallback() {
    window.removeEventListener(EEvent.COMPARATOR_PRODUCTS_CHANGE, this.handleComparatorChange);
  }
  componentWillLoad() {
    this.isMobileView = isMobile();
  }
  productCtasDidChange(newProductCtas) {
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get productIds() {
    return this.productList;
  }
  get totalPages() {
    return Math.ceil(this.productsCount / this.productsPerPage);
  }
  getAdditionalMainQueryParams() {
    if (isV3())
      return { nodeOrSubCatId: this.navigationState, isCategoryListing: false };
    return { N: getNavigationStateParam(this.navigationState) };
  }
  renderProductCardsWrapper() {
    var _a, _b, _c;
    return (h("product-cards-wrapper", { showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, comparator: this.comparatorValue, enableCommerceConnector: this.enableCommerceConnector, "product-ids": this.productIds, host: this.hostWithLocale, class: "range-products-tab__products-list", productCtas: this.productCtas, productOfProductsLabel: this.labels.numberProductsOfAllProductsLabel, productsLabel: this.labels.appProductsLabel, productUrlParams: this.productUrlParams, firstRecNum: (_a = this.resultCount) === null || _a === void 0 ? void 0 : _a.firstRecNum, lastRecNum: (_b = this.resultCount) === null || _b === void 0 ? void 0 : _b.lastRecNum, totalNumRecs: (_c = this.resultCount) === null || _c === void 0 ? void 0 : _c.totalNumRecs, areListGridLabelsShown: false, scrollToProduct: this.scrollToProduct, siteType: this.siteType, enableAppRouting: this.enableAppRouting, additionalMainQueryParams: this.getAdditionalMainQueryParams(), localeCode: this.localeCode, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalFavoriteConfig: this.externalFavoriteConfig }, h("div", { slot: "pills" }, isV3() ? (h("pes-range-filter-pills", { pills: this.pills })) : (h("pes-range-pills", { pills: this.pills })))));
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterMobileViewVisible = !this.isFilterMobileViewVisible;
  }
  renderNodes() {
    return (h("se-block", { color: "none", class: "range-products-tab__nodes-wrapper" }, h("pes-range-nodes", { backUrl: this.currentNode.backUrl, backUrlTitle: this.currentNode.backUrlTitle, levelTitle: this.currentNode.levelTitle, childrenNodes: this.currentNode.childrenNodes, isPBS: this.isPBS })));
  }
  renderFilters() {
    return this.filtrationSmartData ? (h("pes-responsive-filters", { class: "range-products-tab__filters", filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.labels.facetButtonResetAllLabel, viewMoreFacetsLabel: this.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.labels.facetButtonViewLessFilters, headerLabelDesktop: this.labels.commonFiltersFilterBy, headerLabelMobile: this.labels.rangeProductsFiltersLabel, viewProductsLabel: this.labels.viewProductsLabel, viewMoreRefinementsLabel: this.labels.viewMoreLabel, viewLessRefinementsLabel: this.labels.viewLessLabel, isMobileViewVisible: this.isFilterMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.categories, onShowMobileFilter: () => (this.isFilterMobileViewVisible = true) })) : null;
  }
  renderProducts() {
    var _a, _b, _c, _d;
    return (h("se-block", { direction: "row", color: "standard", class: classnames('range-products-tab__products', 'range-products-tab__main-block-wrapper', {
        'range-products-tab__products--desktop': this.isFilterMobileViewVisible
          || (((_a = this.categories) === null || _a === void 0 ? void 0 : _a.length) !== 0 && !this.isMobileCategorySelected),
      }) }, this.isMobileCategorySelected && (h("div", { class: "range-products-tab__products-count" }, this.labels.rangeProductLabel, ": ", this.productsCount)), this.productList && this.isMobileCategorySelected && this.firstLoadedRecNum > 1 && (h("se-button", { block: true, option: "outline", size: "medium", color: "secondary", class: "range-products-tab__load-prev-btn", onClick: this.loadPrevious }, this.labels.loadPreviousLabel)), h("pes-rich-text-information", { richText: this.richText, class: "range-products-tab__rich-text" }), h("pes-range-product-ctas-updater", { buttons: (_b = this.productCtas) === null || _b === void 0 ? void 0 : _b.buttons, myProductsGetter: getMyProductsFromConnector, onButtonsChange: this.handleProductCtasChange }), ((_c = this.productList) === null || _c === void 0 ? void 0 : _c.length) > 0 || this.isLoading
      ? this.renderProductCardsWrapper()
      : !((_d = this.richText) === null || _d === void 0 ? void 0 : _d.length) && (h("pes-filters-no-results", { noResultsClearLink: this.labels.noResultsClearLink, noResultsHeader: this.labels.noResultsHeader, noResultsMessage: this.labels.noResultsMessage })), this.productList && this.productsCount > this.productsPerPage && (h("se-pagination", { hideEdge: true, perPage: this.productsPerPage, total: this.totalPages, value: this.selectedPage, labelValue: this.labels.labelValue, labelPrev: this.labels.previousLabel, labelNext: this.labels.nextLabel, onDidChange: this.onPaginationChange, class: "range-products-tab__desktop-pagination" })), this.productList
      && this.isMobileCategorySelected
      && this.lastLoadedRecNum < this.productsCount && (h("se-button", { block: true, option: "outline", size: "medium", color: "secondary", class: "range-products-tab__load-more-btn", onClick: this.loadMore }, this.labels.loadMoreLabel))));
  }
  render() {
    var _a, _b;
    return (h(Fragment, null, h("se-container", { color: "standard", class: "range-products-tab" }, h("div", { class: {
        'range-products-tab__overlay': true,
        'range-products-tab__overlay--visible': this.isLoading,
      } }), ((_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.showNodes) && this.renderNodes(), ((_b = this.currentNode) === null || _b === void 0 ? void 0 : _b.showProducts) && (h("div", { class: "range-products-tab__main-block-container" }, this.renderFilters(), this.renderProducts())))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};
RangeProductsTab.style = rangeProductsTabCss;

const rangeSoftwareRegistrationTabCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.range-software-registration{position:relative;height:0;padding:30px 0 65%;overflow:hidden;margin:0 auto}.range-software-registration__iframe{border:1px solid #ededed;position:absolute;top:0;width:100%;height:100%;margin-top:25px}:host(:not([dir=\"rtl\"])) .range-software-registration__iframe{left:0}:host([dir=\"rtl\"]) .range-software-registration__iframe{right:0}";

let RangeSoftwareRegistrationTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "range-software-registration" }, h("iframe", { class: "range-software-registration__iframe", src: this.url })));
  }
};
RangeSoftwareRegistrationTab.style = rangeSoftwareRegistrationTabCss;

const rangeWebinarsAndResourcesTabCss = ".range-webinars-and-resources-tab__sdl-content{box-sizing:border-box}.range-webinars-and-resources-tab__sdl-content *,.range-webinars-and-resources-tab__sdl-content *::before,.range-webinars-and-resources-tab__sdl-content *::after{box-sizing:inherit}@media screen and (max-width: 979px){.range-webinars-and-resources-tab__sdl-content{margin-top:20px}}@media screen and (min-width: 980px){.range-webinars-and-resources-tab__sdl-content{margin-top:40px}}.range-webinars-and-resources-tab__sdl-content a:hover{text-decoration:underline}";

let RangeWebinarsAndResourcesTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h("div", { class: "webinars-and-resources-sdl-content range-webinars-and-resources-tab__sdl-content" }, h("pes-sdl-content", { sdlHtmlContent: this.webinarAndResources.sdlContent })));
  }
  get el() { return getElement(this); }
};
RangeWebinarsAndResourcesTab.style = rangeWebinarsAndResourcesTabCss;

const sdlContentCss = ".sdl-content--ecostruxure{padding-bottom:22px;background-color:#ffffff}";

let SDLContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getTabType = (sdlComponentId) => {
      switch (sdlComponentId) {
        case 'ecostruxure':
          return ETabType.ECOSTRUXURE;
        default:
          return null;
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTabClicked(event) {
    if (this.el && event.detail.type === this.getTabType(this.sdlComponentId)) {
      scrollToComponent(this.el);
    }
  }
  componentWillLoad() {
    var _a, _b;
    this.sdlHtmlContent = (_a = tryParse(this._sdlHtmlContent)) !== null && _a !== void 0 ? _a : this.sdlHtmlContent;
    this.sdlComponentId = (_b = tryParse(this._sdlComponentId)) !== null && _b !== void 0 ? _b : this.sdlComponentId;
  }
  componentDidRender() {
    if (this.sdlHtmlContent) {
      pasteScripts(this.el, '.sdl-content');
    }
  }
  render() {
    this.el.innerHTML = '';
    if (this.sdlHtmlContent) {
      try {
        return (h("div", { class: {
            'sdl-content': true,
            'sdl-content--ecostruxure': this.sdlComponentId === 'ecostruxure',
          }, innerHTML: decodeFromURI(this.sdlHtmlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return null;
  }
  get el() { return getElement(this); }
};
SDLContent.style = sdlContentCss;

const tabsCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.pes-tabs{width:100%;background:#ffffff}.pes-tabs--desktop-only{display:none}@media screen and (min-width: 980px){.pes-tabs--desktop-only{display:block}}.pes-tabs .pes-tabs-hidden{display:none}.pes-tabs .tab-primary a{font-weight:400 !important;color:#626469 !important;font-size:16px !important}.pes-tabs .tab-primary a:not(.active){border-top-width:2px !important}.pes-tabs .tab-primary a:hover,.pes-tabs .tab-primary a.active{color:#333333 !important;font-weight:500 !important}.pes-tabs .tab-primary nav[dir=rtl] a{border-left:1px solid #e6e6e6 !important;border-right:0 !important}.pes-tabs .tab-primary nav[dir=rtl] a:first-child{border-right:1px solid #e6e6e6 !important}.pes-tabs__title{margin:0;font-size:inherit;font-weight:inherit;line-height:inherit}.pes-tabs-content{width:100%}.pes-tabs-content .pes-tabs-content-hidden{display:none}";

let PesTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tabs = [];
    this.desktopOnly = false;
    this.activeTabHash = this.setActiveFirstTab();
    this.overviewTab = null;
    this.handleOverviewNavigation = () => this.handleTabClick(this.overviewTab);
    this.setLocationHash = (hash) => {
      window.location.hash = hash;
    };
    this.handleTabClick = (tab) => {
      window.history.replaceState(null, null, ' ');
      if (this.activeTabHash !== tab.hash) {
        setArticleTitle(rangeTabs[tab.hash]);
        send(rangeTabClickEvent, { tabHash: tab.hash });
      }
      this.activeTabHash = tab.hash;
      if (!tab.hideHash) {
        this.setLocationHash(tab.hash);
      }
      scrollToTop(this.hostElementRef);
    };
  }
  connectedCallback() {
    this.setTabFromHash();
    document.addEventListener('activeOverview', this.handleOverviewNavigation);
  }
  disconnectedCallback() {
    document.removeEventListener('activeOverview', this.handleOverviewNavigation);
  }
  setActiveFirstTab() {
    if (this.tabs.length) {
      return this.tabs[0].hash;
    }
    return 'main';
  }
  setTabFromHash() {
    const currentHash = window.location.hash.substring(1);
    const currentTab = this.tabs.find((tab) => {
      return currentHash === tab.hash;
    });
    if (!isEmpty_1(currentTab)) {
      this.activeTabHash = currentTab.hash;
    }
  }
  componentWillLoad() {
    var _a;
    if (!window.location.hash && this.activeTabHash !== TAB_NAMES.Products) {
      this.setLocationHash(this.activeTabHash);
    }
    this.overviewTab = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.find(({ hash }) => hash.includes(TAB_NAMES.Presentation));
  }
  renderTabs() {
    return (h("nav", { dir: document.documentElement.dir || 'auto' }, this.tabs.map((tab) => (h("a", { onClick: () => this.handleTabClick(tab), class: classnames({
        active: tab.hash === this.activeTabHash,
        'pes-tabs-hidden': tab.hidden && tab.hash !== this.activeTabHash,
      }) }, h("h2", { class: "pes-tabs__title" }, tab.title))))));
  }
  render() {
    return (this.tabs.length > 0 && [
      h("se-container", { option: "centered", class: classnames('pes-tabs', { 'pes-tabs--desktop-only': this.desktopOnly }) }, h("se-tabbar", { option: "content" }, this.renderTabs())),
      h("se-container", { option: "centered", class: "pes-tabs-content", color: "standard" }, this.tabs.map((item) => {
        return (h("div", { class: classnames({
            'pes-tabs-content-hidden': this.activeTabHash !== item.hash || item.hidden,
          }) }, item.renderFunction()));
      })),
    ]);
  }
  get hostElementRef() { return getElement(this); }
};
PesTabs.style = tabsCss;

export { RangeInfo as pes_range_node_card, RangeNodeHeader as pes_range_node_header, RangeNodes as pes_range_nodes, RangePresentationTab as pes_range_presentation_tab, RangeProductsTab as pes_range_products_tab, RangeSoftwareRegistrationTab as pes_range_software_registration_tab, RangeWebinarsAndResourcesTab as pes_range_webinars_and_resources_tab, SDLContent as pes_sdl_content, PesTabs as pes_tabs };
